export default "__VITE_ASSET__DPP$ebj___"